import React, { FC, memo } from 'react';
import { FormGroup, FormLabel, FormCheck, FormControl } from 'react-bootstrap';
import { AI_PROVIDERS } from '../../../utils/aiProvider';
import AiProviderLabel from '../../../UIComponents/AiProviderLabel';
import cls from './TariffAiSettings.module.scss';

type TariffAiSettingsProps = {
  availableAiProviders: string[];
  setAvailableAiProviders: (aiProviders: string[]) => void;
  topupDiscountPercent: number;
  setTopupDiscountPercent: (percent: number) => void;
  topupDiscountError?: string;
};

const TariffAiSettings: FC<TariffAiSettingsProps> = memo((props) => {
  const {
    availableAiProviders,
    setAvailableAiProviders,
    topupDiscountPercent,
    setTopupDiscountPercent,
    topupDiscountError,
  } = props;
  const toggleProvider = (aiProvider: string) => {
    if (availableAiProviders.includes(aiProvider)) {
      setAvailableAiProviders(availableAiProviders.filter((item) => item !== aiProvider));
    } else {
      setAvailableAiProviders([...availableAiProviders, aiProvider]);
    }
  };
  return (
    <div className={cls.Container}>
      <h4 className="title-4">AI Settings</h4>
      <div className={cls.Providers}>
        {AI_PROVIDERS.map((aiProvider) => (
          <FormGroup key={aiProvider} className="d-flex justify-content-between align-items-center">
            <FormLabel htmlFor={aiProvider} className="input-title-text mb-0">
              <AiProviderLabel aiProvider={aiProvider} />
            </FormLabel>
            <FormCheck
              type="switch"
              name={aiProvider}
              id={aiProvider}
              onChange={() => toggleProvider(aiProvider)}
              checked={availableAiProviders.includes(aiProvider)}
            />
          </FormGroup>
        ))}
      </div>
      <FormGroup className="position-relative">
        <FormLabel htmlFor="topupDiscountPercent" className="input-title-text">
          Token top-up discount, %
        </FormLabel>
        <FormControl
          type="number"
          name="topupDiscountPercent"
          id="topupDiscountPercent"
          min={0}
          max={100}
          value={topupDiscountPercent}
          isInvalid={!!topupDiscountError}
          onChange={(event) => setTopupDiscountPercent(Number(event.target.value))}
        />
        <FormControl.Feedback type="invalid" tooltip>
          {topupDiscountError}
        </FormControl.Feedback>
      </FormGroup>
    </div>
  );
});

export default TariffAiSettings;
